<div class="ticket-detail-child-card">
  <div class="header">
    <div class="left">
      <img src="../../../../../../../assets/images/icons/icon_children_tree.svg" alt="icon children tree" />
      <span class="header--title">Child Tickets</span>
    </div>
  </div>
  @if (isLoadingChildTickets) {
    <div style="margin-top: 15px">
      @for (item of [1, 2, 3]; track item) {
        <div style="padding: 0px 9px">
          <ngx-skeleton-loader
            [theme]="{
              width: '100%',
              height: '78px',
              background: 'var(--background-input-v2)',
              'border-radius': '16px',
            }"
          ></ngx-skeleton-loader>
        </div>
      }
    </div>
  } @else {
    <!-- Error state for child tickets -->
    @if (apiChildTicketsFailed) {
      <div class="error-state">
        <img src="../../../../../../../assets/images/icons/icon-error-child.svg" />
        <p>There was an error retrieving child tickets.</p>
        <p>Please try again</p>
        <button mat-stroked-button color="primary" (click)="retryFetchChildTickets()">Retry</button>
      </div>
    }
    @if (!apiChildTicketsFailed) {
      <div class="body-container udt-blue-scrollbar">
        @for (childTicket of childTicketsUI; track childTicket.id) {
          <div
            class="body"
            [routerLink]="['/secured/managed-services/tickets', childTicket.id]"
            style="cursor: pointer"
          >
            <div class="body--title">
              <span>{{ childTicket.id }}</span>
            </div>
            <div
              class="body--status"
              [style.background-color]="childTicket.mspStatusData?.colorProfile.backgroundColor"
            >
              <div
                class="circle-indicator"
                [style.background-color]="childTicket.mspStatusData?.colorProfile.foregroundColor"
              ></div>
              <span>{{ childTicket?.mspStatusData?.hubStatus ?? childTicket.statusName }}</span>
            </div>
            <div class="body--description">
              <span>{{ childTicket.summary }}</span>
            </div>
          </div>
        }
      </div>
    }
  }
</div>
